import { Box, TextField, InputLabel, Grid, Tooltip, IconButton } from "@mui/material/";
import SearchIcon from "@mui/icons-material/Search";
import DeleteForeverIcon from "@mui/icons-material/DeleteForever";
import "./../genericModels.css";
import carMaintenanceStyle from "./carMaintenance.module.css";
import { useTranslation } from "react-i18next";
import dayjs from "dayjs";
import utc from "dayjs/plugin/utc";
import GenericFilterBox from "../common/GenericFilterBox";
dayjs.extend(utc);

export const CarMaintenanceFilterAndSearch = (props: any) => {
  let dataFormSearchFieldForCarMaintenance =
    props.dataFormSearchFieldForCarMaintenance;
  let setDataFormSearchFieldForCarMaintenance =
    props.setDataFormSearchFieldForCarMaintenance;
  let resetFormTextForSelectedCarMaintenance =
    props.resetFormTextForSelectedCarMaintenance;
  let SearchMaintenanceCar = props.SearchMaintenanceCar;
  const { t } = useTranslation(["operation"]);

  const Search =(e:any) =>{
    e.preventDefault();
    SearchMaintenanceCar();
  }

 

  return (
    <>
      <Box>
        
          <form id="idMaintenanceForm" onSubmit={(e)=> Search(e)}>
            <GenericFilterBox formId="idMaintenanceForm" onReset={resetFormTextForSelectedCarMaintenance } showExtrasFilters={false}>
            
            
                <Box>
                  <TextField
                    fullWidth
                    //placeholder={t("carMaintenance.filterAndSearch.plateInput")}
                    label={t("carMaintenance.filterAndSearch.plate")}
                    variant="standard"
                    id="plate"
                    name="plate"
                    value={dataFormSearchFieldForCarMaintenance.plate}
                    onChange={(e: any) =>
                      setDataFormSearchFieldForCarMaintenance({
                        ...dataFormSearchFieldForCarMaintenance,
                        plate: e.target.value,
                      })
                    }
                    inputProps={{
                      pattern: "[^%*$)(\"+&?^~Â`£=!@'_/§#-]{0,}",
                       onInput: (event:any) => { 
                      if (event.currentTarget.validity.patternMismatch) 
                     { event.currentTarget.setCustomValidity(t("vehicle.filterModal.regexMessage"))
                    }else {
                      event.currentTarget.setCustomValidity('')
                    }
                    }
                    }}
                  />
                </Box>
              
                <Box>
                  <TextField
                    fullWidth
                    id="vin"
                    name="vin"
                    //placeholder={t("carMaintenance.filterAndSearch.vinInput")}
                    label={t("carMaintenance.filterAndSearch.vin")}
                    value={dataFormSearchFieldForCarMaintenance.vin}
                    onChange={(e: any) =>
                      setDataFormSearchFieldForCarMaintenance({
                        ...dataFormSearchFieldForCarMaintenance,
                        vin: e.target.value,
                      })
                    }
                    inputProps={{
                      pattern: "[^%*$)(\"+&?^~Â`£=!@'_/§#-]{0,}",
                       onInput: (event:any) => { 
                      if (event.currentTarget.validity.patternMismatch) 
                     { event.currentTarget.setCustomValidity(t("vehicle.filterModal.regexMessage"))
                    }else {
                      event.currentTarget.setCustomValidity('')
                    }
                    }
                    }}
                  />
                </Box>
             
            </GenericFilterBox>
          </form>
        </Box>
     
    </>
  );
};
